module.exports = __webpack_public_path__ + "static/media/devconnector.409e4d41.webp";